import { Box } from '@mui/material';
import { useSelector } from 'react-redux';

import { EpisodeGrid } from '@/containers';
import { emptyBookmark } from '@/images';
import { EVENT_CONSTANTS } from '@/services';
import {
  selectBookmarkedEpisodeIds,
  selectPlayerSessionsResult,
  selectUserCompliance,
  useFetchEpisodesQuery,
} from '@/store';

import { EmptyView } from '../EmptyView';

export const Bookmarked = () => {
  const compliance = useSelector(selectUserCompliance);
  const bookmarkedEpisodeIds = useSelector(selectBookmarkedEpisodeIds);
  const { isSuccess: isPlayerSessionsSuccess } = useSelector(
    selectPlayerSessionsResult,
  );
  const {
    data: episodes = [],
    isLoading,
    isSuccess,
  } = useFetchEpisodesQuery(
    {
      episodeIds: bookmarkedEpisodeIds,
      compliance,
    },
    {
      skip: !bookmarkedEpisodeIds.length,
    },
  );

  const isEmpty =
    (isPlayerSessionsSuccess && !bookmarkedEpisodeIds.length) ||
    (isSuccess && !episodes.length);

  return (
    <Box>
      {isEmpty ? (
        <EmptyView
          title="Save for later"
          subtitle="Save episodes you want to hear later and they’ll appear here."
          img={emptyBookmark}
        />
      ) : (
        <EpisodeGrid
          isLoading={isLoading}
          episodes={episodes}
          referrer={{
            page: EVENT_CONSTANTS.PAGE.MY_LUMIQ,
            section: EVENT_CONSTANTS.SECTION.BOOKMARKED,
          }}
        />
      )}
    </Box>
  );
};
